fx.service(class LangService extends fx.Service
{
    constructor()
    {
        super();

        this._langs = [ {id : 1, prefix : "fr", thumb : "assets/icons/fr.png", label : "FR"}, 
                        {id : 2, prefix : "en", thumb : "assets/icons/en.png", label : "EN"},
                        {id : 3, prefix : "es", thumb : "assets/icons/es.png", label : "ES"},
                        {id : 4, prefix : "it", thumb : "assets/icons/it.png", label : "IT"},
                        {id : 5, prefix : "de", thumb : "assets/icons/de.png", label : "DE"}
                    ];

        this.update(fx.currentLang());
    }

    get langs()
    {
        return this._langs;
    }

    get current()
    {
        if (!this._current)
            this._current = this._langs.getItemAt(0);
        return this._current;
    }

    set current(val)
    {
        this._current = val;
        
        this.trigger("updated", this._current);
    }

    update(prefix)
    {
        for(let i = 0; i < this._langs.length; i++)
        {
            let lang = this._langs.getItemAt(i);
            if (lang.prefix == prefix)
            {
                this.current = lang;
            }
        }
    }
    
    lang(id)
    {
        for(let i = 0; i < this._langs.length; i++)
        {
            let lang = this._langs.getItemAt(i);
            if (lang.id == id)
                return lang;
        }
    }
});